<div 
  class="bg-bush-green-10 flex p-2 relative min-h-8 mb-2"
  [ngClass]="{
    'min-h-8': store.widgetIsExpanded(),
    'h-10 overflow-y-hidden': !store.widgetIsExpanded(),
  }"
>
  <div class="text-body-2 flex-1 min-w-0 w-12 overflow-hidden">
    @if (hasSummary()) {
      <div class="max-w-full" [ngClass]="{'whitespace-nowrap text-ellipsis overflow-hidden': !store.widgetIsExpanded()}">
        <span class="avatar avatar-xs maximizer-icons icon-iq-boost icon-16 mr-2 bg-inserv-10 inline-flex align-middle"></span>

        <span class="inline font-medium align-middle">{{ title() }}&nbsp;</span>
        <span
          class="align-middle text-clip inline"
          [innerHTML]="summary() | clickableRef | entityKeyRef | deAnonymizer | safeHtml"
        ></span>
        <span 
          class="inline font-medium align-middle cursor-pointer text-link pl-0.5"
          (click)="openIqBoost()"
        >
          {{ 'iqboost.summary.showMore' | translate }}
        </span>
      </div>
    } @else if (!loading()) {
      <span class="avatar avatar-xs maximizer-icons icon-iq-boost icon-16 mr-2 bg-inserv-10 inline-flex align-middle"></span>
      <span class="align-middle text-clip inline">
        {{ 'iqboost.summary.errorMessage' | translate }}
      </span>
    }
  </div>

  @if (hasSummary()) {
    <i
      [ngClass]="{
        'icon-chevron-up': store.widgetIsExpanded(),
        'icon-chevron-down': !store.widgetIsExpanded(),
      }"
      (click)="toggleExpandedView()"
      class="fa-icons icon-16 icon-chevron-down ml-4 mr-2 pt-1 text-bush-green-140 cursor-pointer"
    >
    </i>
  }

  @if (loading()) {
    <div class="absolute inset-0 flex items-center">
      <div class="flex items-center ml-4 gap-2">
        <div class="w-6 h-6 mr-3">
          <maximizer-loader type="kendo" class="!w-auto !h-auto !top-auto !left-auto relative [&_.mask]:!hidden mt-1.5"></maximizer-loader>
        </div>
        <span class="text-bush-green-140">
          {{ 'iqboost.generatingSummary' | translate }}
        </span>
      </div>
    </div>
  }
</div>

@if (store.showErrorMessageDialog()) {
  <kendo-dialog
    [width]="460"
    [height]="175"
    [style.z-index]="'.k-window, .ui-dialog' | maxZIndex: 99990"
  >
    <div class="px-5" >
      <h6 class="py-4 flex text-black">
        {{ 'iqboost.error.title' | translate }}
      </h6>

      <div class="flex">
        <img
          class="w-[62px] mr-4"
          [src]="cdn + '/assets/images/ai-error-message.svg'"
          alt="Loading…"
        />

        <span class="text-body-2 text-black whitespace-pre-line">
          {{ 'iqboost.error.message' | translate }}
        </span>
      </div>

      <div class="flex justify-end mt-5">
        <button
          kendoButton
          class="uppercase"
          themeColor="primary"
          (click)="store.setShowErrorMessageDialog(false)"
        >
          {{ 'iqboost.buttons.ok' | translate }}
        </button>
      </div>
    </div>
  </kendo-dialog>
}
